import React from 'react';
import { Link } from 'react-router-dom';
import { BadgeCheck, CarFront, CheckCircle2, ClipboardCheck, FileUp, QrCode, Sticker } from 'lucide-react';
import { PageHeader } from '../../components/common/PageHeader';
import { Panel } from '../../components/common/Panel';
import { toBn } from '../../utils/bn';
const steps = [{
  icon: FileUp,
  title: 'প্রয়োজনীয় তথ্য/ডকুমেন্ট জমা',
  who: 'মালিক / চালক',
  desc: 'ব্লু-বুক, ফিটনেস, ট্যাক্স টোকেন, NID, চালকের লাইসেন্স ও ছবি। BRTA তথ্য আগেই সিস্টেমে আমদানিকৃত।',
  time: '১ দিন',
  to: '/admin/brta-import'
}, {
  icon: ClipboardCheck,
  title: 'তথ্য যাচাই',
  who: 'ডাটা যাচাইকারী',
  desc: 'BRTA উৎস তথ্যের সাথে ডিএমপি তথ্য পাশাপাশি মিলিয়ে অমিল সংশোধন।',
  time: '১–২ দিন',
  to: '/admin/validation'
}, {
  icon: BadgeCheck,
  title: 'অনুমোদন',
  who: 'অনুমোদনকারী কর্মকর্তা',
  desc: 'কর্মকর্তা পর্যালোচনা শেষে অনুমোদন, সংশোধনে ফেরত বা প্রত্যাখ্যান।',
  time: '১ দিন',
  to: '/admin/approval'
}, {
  icon: QrCode,
  title: 'QR স্টিকার তৈরি',
  who: 'স্টিকার অপারেটর',
  desc: 'গাড়ির জন্য CNG-QR ও প্রত্যেক চালকের জন্য DRV-QR স্বয়ংক্রিয়ভাবে তৈরি।',
  time: 'তাৎক্ষণিক',
  to: '/admin/qr'
}, {
  icon: Sticker,
  title: 'CNG ও Driver Sticker ইস্যু',
  who: 'স্টিকার অপারেটর',
  desc: 'ব্যাচ প্রিন্ট শেষে বিভাগীয় কার্যালয় থেকে NID যাচাই করে হস্তান্তর ও রসিদ প্রদান।',
  time: '২–৩ দিন',
  to: '/admin/issue'
}, {
  icon: CarFront,
  title: 'CNG গাড়িতে Sticker স্থাপন',
  who: 'মালিক (ট্রাফিক কর্মকর্তার উপস্থিতিতে)',
  desc: 'সামনের কাচের ভেতরের দিকে বাম কোণে স্থাপন। চালক QR কার্ড সাথে রাখবেন।',
  time: 'ইস্যুর দিন',
  to: '/admin/stickers'
}, {
  icon: CheckCircle2,
  title: 'সক্রিয়/যাচাইকৃত CNG',
  who: 'সিস্টেম',
  desc: 'রোডসাইডে ট্রাফিক পুলিশ স্ক্যান করলেই যাচাইকৃত তথ্য প্রদর্শিত হবে।',
  time: '—',
  to: '/mobile'
}];
export function IssueProcess() {
  return <div className="space-y-4" data-id="element-2035" data-mp="1lsgk5qr218j7">
      <PageHeader title="QR স্টিকার ইস্যু প্রক্রিয়া" subtitle="সিএনজি মালিক ও চালকের দৃষ্টিকোণ থেকে — আবেদন থেকে সক্রিয় হওয়া পর্যন্ত ৭টি ধাপ (আনুমানিক ৫–৭ কার্যদিবস)" data-id="element-2036" data-mp="16xaej4vvfbqe" />
      <Panel data-id="element-2037" data-mp="ss1rrowzs1th">
        <ol className="relative grid gap-0" data-id="element-2038" data-mp="ssjvf6lzhibf">
          {steps.map((s, i) => <li key={s.title} className="relative grid grid-cols-[56px_1fr] gap-4 pb-6 last:pb-0 md:grid-cols-[56px_1fr_220px]" data-id="element-2039" data-mp="o1bku78x3qwo" data-mpi={i}>
              {i < steps.length - 1 && <span className="absolute left-[27px] top-14 h-[calc(100%-56px)] w-0.5 bg-navy-200" aria-hidden data-id="element-2040" data-mp="j308npv5h4ba" />}
              <span className={`relative z-10 flex h-14 w-14 items-center justify-center rounded-full border-2 ${i === steps.length - 1 ? 'border-bdgreen-600 bg-bdgreen-600 text-white' : 'border-navy-800 bg-white text-navy-800'}`} data-id="element-2041" data-mp="e4yu9i8o5t65">
                <s.icon className="h-6 w-6" strokeWidth={1.8} data-id="element-2042" data-mp="11sq48f6qlu49" />
              </span>
              <div className="rounded-lg border border-border bg-white p-4" data-id="element-2043" data-mp="11uje03cncugh">
                <p className="text-xs font-semibold text-slate-400" data-id="element-2044" data-mp="wtdjbzzfex4b">ধাপ {toBn(i + 1)}</p>
                <p className="font-heading text-lg font-bold text-navy-900" data-id="element-2045" data-mp="3mkiiu3yeanev">{s.title}</p>
                <p className="mt-1 text-sm text-slate-600" data-id="element-2046" data-mp="3hj2x09oe8cvf">{s.desc}</p>
              </div>
              <div className="col-start-2 flex flex-col justify-center gap-1 text-xs md:col-start-3" data-id="element-2047" data-mp="1x2v2oxsbe9wv">
                <p data-id="element-2048" data-mp="221y6yg0h0c3s"><span className="text-slate-500" data-id="element-2049" data-mp="221y5scoqi627">দায়িত্বপ্রাপ্ত:</span> <b className="text-navy-900" data-id="element-2050" data-mp="26zzt59t70rjh">{s.who}</b></p>
                <p data-id="element-2051" data-mp="26yeylk6vp8lm"><span className="text-slate-500" data-id="element-2052" data-mp="26yetj5s0uier">সময়:</span> <b className="text-navy-900" data-id="element-2053" data-mp="2bqg66st3qb5b">{s.time}</b></p>
                <Link to={s.to} className="font-semibold text-navy-600 hover:underline" data-id="element-2054" data-mp="2bs10chbi7s2n">সংশ্লিষ্ট স্ক্রিন দেখুন →</Link>
              </div>
            </li>)}
        </ol>
      </Panel>
    </div>;
}